export default __webpack_public_path__ + "static/media/39_mobile.6ffa3092.jpg";